import { FormatMessageType } from '@hooks/useValidation';
import { BETWEEN, ELEMENT_IN_LIST, REQUIRED } from '@utils/validation/validation.constant';
import Yup from '@utils/validation/yup-extended';

export function groupSchemaValidation(formatMessage: FormatMessageType) {
  return Yup.object({
    name: Yup.string().required(formatMessage({ id: REQUIRED })),
    defaultPlatform: Yup.string()
      .nullable()
      .notRequired()
      .when(['platforms'], ([platforms], schema) => {
        if (platforms.length !== 0) {
          return schema.test(
            'default-platform-in-platforms',
            formatMessage(
              { id: ELEMENT_IN_LIST },
              {
                element: formatMessage({ id: 'components.usersManagement.groups.defaultPlatform' }),
                list: formatMessage({ id: 'components.usersManagement.groups.platforms' }),
              },
            ),
            (value) => platforms.includes(value),
          );
        }
        return schema;
      }),
    inactivityTime: Yup.mixed<number>()
      .nullable()
      .notRequired()
      .test('is-null-or-number', formatMessage({ id: REQUIRED }), (value) => value !== undefined)
      .test(
        'is between 0 and 60',
        formatMessage({ id: BETWEEN }),
        (value) => typeof value !== 'number' || (value <= 60 && value > 0),
      ),
  });
}
